// extracted by mini-css-extract-plugin
module.exports = {"input_control":"verhouding_input_control__39Wvh"};